import React, { Component, Fragment } from 'react';
import HeaderBack from '../components/HeaderBack';
import ListPlaces from './components/ListPlaces';
import resizer from 'components/common/Resizer';
import { setCustomerAddresses }
  from 'components/actions/serviceActions';
import { connect } from 'react-redux';
import axios from 'components/AppRequest';
import sortBy from 'lodash/sortBy';
import AccountMapContainer from './components/AccountMapContainer';
import {
  fetchPriceList
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

class Places extends Component {

  componentDidMount() {
    this.fetchAddresses();
    this.props.fetchPriceList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshParam !== prevProps.refreshParam) {
      this.fetchAddresses();
    }
  }

  fetchAddresses = () => {
    axios.get('/pwa/customer/fetch-addresses')
      .then(response => {
        var addresses = response.data;
        var sortedAddresses = sortBy(addresses, (o) => {
          if (o.is_bus_stop) {
            return o.bus_stop_name;
          } else {
            return o.name;
          }
        });
        this.props.setCustomerAddresses(sortedAddresses);
      })
      .catch(err => {
        console.log('err', err)
      });
  }

  trans = (key,pref  = "content.account.places") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  render() {
    const isMobile = this.props.windowWidth <= 639;
    if (isMobile) {
      return (
        <div className="content">
          <div className="content__desc content__desc--wider">
            <HeaderBack locale={this.props.locale} />
            <h1>{this.trans('title')}</h1>
            <ListPlaces />
          </div>
        </div>
      );
    } else {
      return (
        <div className="content" style={{ padding: '0' }}>
          <div className="grid-layout">
            <div className="grid-layout__item grid-layout__item--desc grid-layout__item--center">
              <HeaderBack locale={this.props.locale}/>
              <div className="content__desc content__desc--wider">
                <h1><T>content.account.places.myPlaces</T></h1>
                <ListPlaces />
              </div>
            </div>
            <div className="grid-layout__item grid-layout__item--desc grid-layout__item--map">
              <AccountMapContainer isMobile={isMobile} />
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    refreshParam: state.service.refreshCustomerAddressesList,
    customerAddresses: state.service.customerAddresses
  };
};

export default resizer(
  connect(
    mapStateToProps,
    { setCustomerAddresses, fetchPriceList }
  )(Places)
);

